import { render, staticRenderFns } from "./AdminImports.vue?vue&type=template&id=68c55dc8"
import script from "./AdminImports.vue?vue&type=script&lang=js"
export * from "./AdminImports.vue?vue&type=script&lang=js"
import style0 from "./AdminImports.vue?vue&type=style&index=0&id=68c55dc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports